import React from 'react'
import "./Shipping.css"
import ShippingHead from './ShippingHead'
import ShippingPara from './ShippingPara'
const Shipping = () => {
  return (
    <div className='shipContainer'>
      <ShippingHead/>
      <ShippingPara/>
    </div>
  )
}

export default Shipping
